// Resident Advisor listing status — timeline scroll of our events, each upcoming
// one marked Listed or with a "List on Resident Advisor" button. Thin wrapper
// over the shared DistributionListings view.

import DistributionListings from './DistributionListings.jsx';

export default function ResidentAdvisorListings() {
  return (
    <DistributionListings
      title="Resident Advisor"
      platform="resident_advisor"
      listEndpoint="resident_advisor/listings"
      actionLabel="List on Resident Advisor"
      actioningLabel="Listing…"
      notConnectedMsg="Resident Advisor is not connected for this tenant. Connect it in Settings to see listing status."
    />
  );
}
